import { useState } from "react";
import { Joyride, STATUS } from "react-joyride";

export default function ProductTour({ run, setRun }) {
  const [steps] = useState([
    {
      target: ".global-sidebar",
      content: "Welcome to Learnlia! This sidebar is your main navigation hub. Let's briefly explain the core features of the platform.",
      placement: "right",
      disableBeacon: true,
    },
    {
      target: "a[href='/tracks']",
      content: "Tracks are highly structured, curated curriculums designed by experts to guide you from zero to job-ready. They include projects, AI assessments, and official certification.",
      placement: "right",
      disableBeacon: true,
    },
    {
      target: "a[href='/roadmaps']",
      content: "Roadmaps let YOU be in control. You can generate custom step-by-step career roadmaps and populate them with whatever resources or projects you prefer.",
      placement: "right",
      disableBeacon: true,
    },
    {
      target: "a[href='/my-courses']",
      content: "Courses are individual, independent video playlists or subjects you are studying. They aren't part of a formal track, but still contribute to your daily streak!",
      placement: "right",
      disableBeacon: true,
    },
    {
      target: "a[href='/add-course']",
      content: "Use Add Course to easily paste YouTube playlist URLs and import external learning materials natively into Learnlia for focused, distraction-free studying.",
      placement: "right",
      disableBeacon: true,
    },
    {
      target: ".streak-card",
      content: "This is your Streak. Consistency is key! Earn your streak daily by completing track phases or studying courses.",
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: ".tpc-suggestions-block",
      content: "Once you set a goal, Learnlia Intelligence automatically curates the PERFECT next tracks to get you hired or fluent.",
      placement: "top",
      disableBeacon: true,
    },
    {
      target: ".analytics-grid",
      content: "This is your Analytics Center. Visualize your focus blocks, track retention, and score your consistency over 90 days.",
      placement: "top",
      disableBeacon: true,
    },
    {
      target: ".theme-switch",
      content: "Prefer coding in the dark? Seamlessly toggle Dark Mode and Light Mode right here.",
      placement: "left",
      disableBeacon: true,
    },
    {
      target: ".xp-widget",
      content: "Every action earns you XP. Build your daily streaks and level up to unlock exclusive badges and Pro perks!",
      placement: "left",
      disableBeacon: true,
    }
  ]);

  const handleJoyrideCallback = (data) => {
    const { status } = data;
    const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];
    if (finishedStatuses.includes(status)) {
      setRun(false);
      // We can also store completion in local storage
      localStorage.setItem("learnlia_tour_completed", "true");
    }
  };

  return (
    <Joyride
      callback={handleJoyrideCallback}
      continuous={true}
      run={run}
      scrollToFirstStep={true}
      showProgress={true}
      showSkipButton={true}
      steps={steps}
      styles={{
        options: {
          zIndex: 10000,
          primaryColor: "#2563eb",
          textColor: "#0f172a",
          backgroundColor: "#ffffff",
          overlayColor: "rgba(0, 0, 0, 0.5)",
        },
        buttonNext: {
          borderRadius: "8px",
          fontWeight: 700,
        },
        buttonSkip: {
          color: "#64748b",
        },
      }}
    />
  );
}
